import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

import { Banners } from '@sorare/core/src/components/layout/Banners';
import { MobileAppBottomPortalReceiver } from '@sorare/core/src/components/navigation/AppNavigation';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { useTitleAndDescription } from '@sorare/core/src/hooks/useTitleAndDescription';
import {
  SaleType,
  TOKENS_STACKED_LIMIT,
  createCardSorts,
} from '@sorare/core/src/lib/algolia';
import { metadatas } from '@sorare/core/src/lib/seo/football';

import { PageTemplate } from '@sorare/marketplace/src/components/market/PageTemplate';
import { useDefaultFilters } from '@sorare/marketplace/src/hooks/useDefaultFilters';
import { instantBuyMarketFilters } from '@sorare/marketplace/src/searchCards/football/cardFilters';

import { FootballCardSearch } from 'components/searchCards/FootballCardSearch';

export const InstantBuyPage = () => {
  const { isIosApp, isMarketAuthorizedIosApp } = useIsMobileApp();
  const [searchParams] = useSearchParams();

  useTitleAndDescription(
    metadatas.instantBuy.title,
    metadatas.instantBuy.description
  );

  const filters = useDefaultFilters({ primaryOffer: true, bundled: false });

  const defaultSort = 'Cards On Sale Popular Player';

  const isOnboardingFlow = !!searchParams.get('isOnboardingFlow');
  const isNewNavigation = !!searchParams.get('isNewNavigation');

  const cardSorts = useMemo(
    () =>
      createCardSorts({
        indexPrefix: 'Cards On Sale',
        withBestValue: false,
        withPopularPlayer: true,
        withHighestAverageScore: true,
        withEndingSoon: false,
        withNew: false,
      }),
    []
  );

  return (
    <>
      {!!(!isIosApp || isMarketAuthorizedIosApp) && <Banners />}
      <PageTemplate showBack>
        <FootballCardSearch
          sorts={cardSorts}
          defaultSort={defaultSort}
          cardFilters={instantBuyMarketFilters}
          defaultFilters={filters}
          analyticsTags={['InstantBuy', 'Football']}
          topic={{ type: 'instantBuy', label: '' }}
          onlyPrimary
          stackableTypes={[SaleType.PRIMARY_OFFER]}
          hideStackedSwitch
          distinct={TOKENS_STACKED_LIMIT}
          hideSorareUser
          removeFinishedPrimaryBuys
          displayVideoTutorial
          isOnboardingFlow={isOnboardingFlow}
          isNewNavigation={isNewNavigation}
        />
      </PageTemplate>

      {!!isIosApp && (
        <MobileAppBottomPortalReceiver id="above-bottom-bar-portal" />
      )}
    </>
  );
};
export default InstantBuyPage;
